import { updateTheme } from "./updateTheme"

export function updateThemeWithoutTransitions(savedTheme) {
  updateTheme(savedTheme)
  document.documentElement.classList.add("[&_*]:!transition-none")
  window.setTimeout(() => {
    document.documentElement.classList.remove("[&_*]:!transition-none")
  }, 0)
}
